import { ExtractPropTypes, PropType } from 'vue'
import { InputProps as WxInputProps } from '@tarojs/components'
// import {FormItem} from '@nutui/nutui-taro'

export const digitInputProps = {

  /* 值 */
  modelValue: {
    type: String,
    default: '',
  },

  /* 文本对齐 */
  textAlign: {
    type: String as PropType<'left' | 'right'>,
    default: 'left',
  },

  /* 最大长度 */
  maxLength: {
    type: Number,
    default: 999,
  }
}

export type DigitInputProps = Partial<ExtractPropTypes<typeof digitInputProps>> & WxInputProps